import { render, staticRenderFns } from "./SerialBox.vue?vue&type=template&id=1fa27a3c&scoped=true"
import script from "./SerialBox.vue?vue&type=script&lang=js"
export * from "./SerialBox.vue?vue&type=script&lang=js"
import style0 from "./SerialBox.vue?vue&type=style&index=0&id=1fa27a3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa27a3c",
  null
  
)

export default component.exports